import React from 'react';
import { ArrowRight, Shield, TrendingUp } from 'lucide-react';

const Hero = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Hero Content */}
          <div className="fade-in-up">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/nsa-logo.png" 
                alt="NSA Financial Services" 
                className="logo-hero scale-in"
              />
            </div>
            
            <h1 className="heading-hero fade-in-up delay-1">
              Guiding Your Wealth with 
              <span className="text-primary-gold"> Integrity & Insight</span>
            </h1>
            
            <p className="text-large mb-8 fade-in-up delay-2">
              NSA Financial Services is dedicated to helping clients navigate both market volatility and long-term financial goals—through personalized, trustworthy guidance.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 fade-in-up delay-3">
              <button onClick={scrollToServices} className="btn-primary">
                <TrendingUp size={20} />
                Discover Our Services
                <ArrowRight size={20} />
              </button>
              
              <button onClick={scrollToContact} className="btn-secondary">
                <Shield size={20} />
                Get in Touch
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12 fade-in-up delay-3">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary-green font-poppins"></div>
                  <div className="text-sm text-secondary"></div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary-green font-poppins"></div>
                  <div className="text-sm text-secondary"></div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary-green font-poppins"></div>
                  <div className="text-sm text-secondary"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Visual */}
          <div className="hidden md:block fade-in-up delay-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-gold to-accent-green rounded-full opacity-20 animate-pulse"></div>
              <div className="relative bg-white rounded-3xl p-8 shadow-2xl">
                <div className="text-center mb-6">
                  <h3 className="heading-card text-primary-green mb-4">
                    Your Financial Growth Partner
                  </h3>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div className="bg-light-gold rounded-xl p-4">
                      <div className="font-semibold text-primary-green">Mutual Funds</div>
                      <div className="text-secondary">Professional Management</div>
                    </div>
                    <div className="bg-cream-bg rounded-xl p-4">
                      <div className="font-semibold text-primary-green">Fixed Deposits</div>
                      <div className="text-secondary">Secure Returns</div>
                    </div>
                    <div className="bg-cream-bg rounded-xl p-4">
                      <div className="font-semibold text-primary-green">Financial Planning</div>
                      <div className="text-secondary">Strategic Guidance</div>
                    </div>
                    <div className="bg-light-gold rounded-xl p-4">
                      <div className="font-semibold text-primary-green">Insurance</div>
                      <div className="text-secondary">Comprehensive Coverage</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;